import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fs-8 while-spaces" }

import { translate } from '@/languages/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
  messageCode: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(translate)(__props.messageCode)), 1))
}
}

})